<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <dark-Toggler class="d-none d-lg-block" />
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <!-- <locale /> -->
      <origin />
      <agency/>
      <user-dropdown :toggleVerticalMenuActive="toggleVerticalMenuActive" />
    </b-navbar-nav>
  </div>
</template>

<script>
import { BLink, BNavbarNav } from 'bootstrap-vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import authService from '@/providers/authService';
import UserDropdown from './UserDropdown.vue';
import Origin from './Origin.vue';
import Agency from './Agency.vue';
// import Locale from './Locale.vue';

export default {
  components: {
    BLink,
    BNavbarNav,
    
    // Navbar Components
    DarkToggler,
    UserDropdown,
    Origin,
    Agency,
    // Locale
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  mounted() {
    // console.log('currentUser: ', this.$store.state.auth.currentUser);
  },
  computed: {
  },
  methods: {
    onLogout() {
      authService.logout();
    }
  }
}
</script>
